<template>
  <div>
    <div class="overview_text">
      <v-icon>equalizer</v-icon>Total 그래프
      <div class="select_box" v-if="isMul">
        <select v-model="selectedChart">
          <option disabled value="">Please select one</option>
          <option v-for="(name, index) in chartNames" :key="index">{{name}}</option>
        </select>
      </div>
    </div>
    <div id='chartContainer' class='chartContainer'>
      <CtrChart
      :chartData="chartDatas.chartData[selectedIdx]"
      :chartName="chartDatas.chartNames[selectedIdx]"
      :ctrAvg="avgCtr.ctr"></CtrChart>
      <!-- <VtrChart
      :chartData="chartDatas.chartData[selectedIdx]"
      :chartName="chartDatas.chartNames[selectedIdx]"
      :vtrAvg="avgCtr.vtr"
      v-if="isInterPlay"></VtrChart> -->
    </div>
    <div>
      <div class="table_text"><v-icon>beenhere</v-icon>Total 리포트</div>
      <div class="topTableWrap over_table">
        <component :is="currentView"
          :campaignType="campaignType"
          :contractData="contractData.contract"
          :parseDataType="parseDataType"
          :contractTotal="contractTotal"></component>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters, mapMutations } from 'vuex'
  import '@/assets/chart/c3.min.css'
  import {
    parseDataType,
    getContractTotal,
    isInterPlay,
    checkCampaignType
  } from '@/assets/func'

  import CtrChart from '@/components/campaign/chart/CtrChart'
  import VtrChart from '@/components/campaign/chart/VtrChart'

  import ContractBaseTable from '@/components/campaign/contract/ContractBaseTable'
  import ContractInterPlay from '@/components/campaign/contract/ContractInterPlay'
  import ContractInterPlayCV from '@/components/campaign/contract/ContractInterPlayCV'
  import ContractInterPlayCPV from '@/components/campaign/contract/ContractInterPlayCPV'
  import ContractInterPlayCPCV from '@/components/campaign/contract/ContractInterPlayCPCV'

  export default {
    name: 'overview',
    data () {
      return {
        selectedChart: ''
      }
    },
    components: {
      CtrChart,
      VtrChart,
      ContractBaseTable,
      ContractInterPlay,
      ContractInterPlayCV,
      ContractInterPlayCPV,
      ContractInterPlayCPCV
    },
    methods: {
      ...mapMutations([
        'setCampaignDetailTap'
      ]),
      checkCampaignType () { // 상품별 페이지 -> 일반상품, 인터플레이 구분
        return checkCampaignType(
          this.isInterPlay,
          this.currentCampaign.campaign_nm,
          this.contractData.contract
        )
      },
      parseDataType (data) {
        return parseDataType(data)
      }
    },
    computed: {
      ...mapState({
        campaignInfo: state => {
          return state.campaign.campaignInfo
        },
        contractData: state => state.campaign.contractData,
        currentCampaign: state => state.campaign.currentCampaign
      }),
      ...mapGetters({
        chartDatas: 'chartDatas'
      }),
      campaignType () {
        return this.checkCampaignType()
      },
      chartNames () {
        return this.chartDatas.chartNames
      },
      selectedIdx () {
        return this.chartDatas.chartNames.indexOf(this.selectedChart)
      },
      avgCtr () {
        let obj = {}
        obj.ctr = this.chartDatas.avgData[this.selectedIdx] ? this.chartDatas.avgData[this.selectedIdx].ctr : '0.00'
        if (this.isInterPlay) {
          obj.vtr = this.chartDatas.avgData[this.selectedIdx] ? this.chartDatas.avgData[this.selectedIdx].vtr : '0.00'
        }
        return obj
      },
      contractLength () { // 상품 수
        return this.contractData.contract.length
      },
      contractTotal () {
        return getContractTotal(this.contractData.contract, this.campaignType, this.isInterPlay)
      },
      currentView () { // 일반 상품, 인터플레이 종류에따라 보여줄 컴포넌트 변경
        switch (this.campaignType) {
          case 'LBIP':
            return 'ContractBaseTable'
          case 'BASE':
            return 'ContractBaseTable'
          case 'CV':
          case 'CVPIP':
            return 'ContractInterPlayCV'
          case 'CPV':
            return 'ContractInterPlay'
          case 'CPCV':
            return 'ContractInterPlayCPCV'
          default :
            return 'ContractInterPlay'
        }
      },
      isMul () {
        if (this.contractLength > 1) return true
        return false
      },
      isInterPlay () {
        return isInterPlay()
      }
    },
    created () {
      this.setCampaignDetailTap('overview')
    },
    watch: {
      campaignInfo (val) { // 캠페인 상세 데이터 변경 감지 (ajax -> response 제대로 받아오면 변경)
        let t = this.contractData.contract[0]
        if (t === undefined) {
          this.selectedChart = ''
          return
        }

        this.selectedChart = this.isMul ? this.chartNames[0] : this.chartNames[1]
      }
    },
    mounted () {
      let t = this.contractData.contract[0]
      if (t === undefined) return

      this.selectedChart = this.isMul ? this.chartNames[0] : this.chartNames[1]
      window.scroll(0, 0)
      document.body.scrollTop = 0
    },
    destroyed () {
      let chart = document.getElementById('chart_0')
      if (chart) chart.destroy()
    }
  }
</script>

<style scoped>
  .overview_text {
    width: calc(100% - 5px);
    height: 25px;
    max-width: 1500px;
    line-height: 25px;

    margin: 0 auto;
    margin-bottom: 3px;
    color: #689f38;
    font-weight: 500;
    padding-left: 5px;
  }
  .overview_text i {
    vertical-align: middle;
    margin-right: 5px;
  }
  .select_box {
    float: right;
    margin-right: 5px;
  }
  .select_box select {
    height: 23px;
    border-radius: 5px;
  }
  .over_table {
    margin-bottom: 10px;
  }
  .table_text {
    height: 25px;
    line-height: 25px;
    margin: 0 auto;
    color: #689f38;
    font-weight: 500;
    padding-left: 5px;
    margin-bottom: 3px;
  }
  .table_text i {
    vertical-align: middle;
    margin-right: 5px;
  }
</style>

<style>
  .chartContainer {
    max-width: 1500px;
    margin-left: auto;
    margin-right: auto;
    overflow-x: hidden;
  }
  .c3 {
    background: #fff;
    border-bottom-left-radius: 7px;
    border-bottom-right-radius: 7px;
    box-shadow: 0 2px 1px rgba(0,0,0,.2);
    border: 1px solid #d1dce3;
    border-top: none;
    margin-bottom: 15px;
  }
  .c3-axis.c3-axis-x g line {
    display: none
  }

  .chartContainer .c3-shape.c3-bar {
    stroke: #eaeaea !important;
    /* opacity: 0.9 !important; */
    stroke-width: 1px;
  }

  .c3-line {
    stroke-width: 2px  !important;
  }
  .c3-shapes-end-rate .c3-circle {
    stroke: #f9835e !important;
    stroke-width: 2px !important;
    fill: #fff !important;
  }
  .c3-shapes-vtr .c3-circle, .c3-shapes-ctr .c3-circle {
    stroke: #ea5c58 !important;
    stroke-width: 2px !important;
  }
  .avgCtr line {
    stroke: #44A812 !important;
  }
  .avgCtr text {
    fill: #000 !important;
    font-weight: bold !important;
    font-size: 11px !important;
  }
  .chartTitle {
    padding: 5px;
    width: calc(100% - 12px);
    height: 20px;
    margin: 0 auto;
    text-align: center;
    background: #fff;
    font-weight: bold;
    letter-spacing: 1px;
    border-top-left-radius: 7px;
    border-top-right-radius: 7px;
    border: 1px solid #d1dce3;
    border-bottom: none;
  }
  .chartTitle {
    margin-top: 10px;
  }
  .chartTitle:nth-child(1) {
    margin-top: 0;
  }
  .c3-xgrid, .c3-ygrid {
    stroke: #cdcdcd !important;
    stroke-dasharray: 0 !important;
  }
  .tick text tspan {
    white-space: nowrap;
    fill: #777777;
    font-weight: 600;
  }
  .c3-axis-y2 line {
    display: none;
  }

  .c3 .c3-axis path, .c3 .c3-axis line {
    stroke: #cdcdcd
  }
  .legend_box_wrap {
    display: inline-block;
  }
  .legend_box:hover {
    cursor: pointer !important;
  }
  .legend_box_wrap:hover .legend_box:not(:hover) {
    opacity: 0.7 !important;
  }
  .legend_box {
    display: inline-block;
  }
  .legend {
    background: #fff;
    border-left: 1px solid #d1dce3;
    border-right: 1px solid #d1dce3;
    text-align: center;
  }
  .ctr_img, .imp_img {
    vertical-align: middle;
    width: 25px;
    margin-left:5px;
    margin-right:5px;
    padding-bottom: 3px;
  }

  .c3-tooltip .name {
    font-size: 10pt;
    font-weight: 500;
    text-align: left;
  }
  .c3-tooltip .name .tootip-img{
    margin-right: 3px;
    width: 25px !important;
  }
</style>


// WEBPACK FOOTER //
// Overview.vue?70fbd4c2